<template>
    <div class="about-us">
    <PCNavbar class="hidden-xs-only none_992" />
    <MobileNavBar class="hidden-md-and-up" />

        <AboutUsHeader title="关于我们" content="这是关于我们的页面内容。"  class="hidden-xs-only none_992" />
        <AboutUsHeaderMobile  class="hidden-md-and-up" title="关于我们" content="这是关于我们的页面内容。" />
        <CompanyIntro  class="hidden-xs-only none_992"/> <!-- 新增公司简介模块 -->
         <CompanyIntroMobile  class="hidden-md-and-up" /> <!-- 新增公司简介手机模块 -->
        <HonorCertificates  class="hidden-xs-only none_992"/> <!-- 新增荣誉资质模块 -->
        <HonorCertificatesMobile  class="hidden-md-and-up" /> <!-- 新增荣誉资质模块 -->
        <Partners   class="hidden-xs-only none_992"/>
         <PartnersMobile  class="hidden-md-and-up" />
        <ContactUs   class="hidden-xs-only none_992"/> <!-- 新增联系我们模块 -->
   <ContactUsMobile class="hidden-md-and-up" /> <!-- 新增联系我们模块 -->
    <CallMe class="hidden-xs-only none_992" />
    <MobileCallme class="hidden-md-and-up" />
    </div>
</template>

<script>
import PCNavbar from '@/components/navbar/index';
import MobileNavBar from '@/components/navbar/MobileNavBar.vue';
import CallMe from '@/components/callme/index';
import MobileCallme from '@/components/callme/callMeMile.vue';
import AboutUsHeader from '@/components/AboutUsHeader/index.vue';
import AboutUsHeaderMobile from '@/components/AboutUsHeaderMobile/index.vue';
import CompanyIntro from '@/components/CompanyIntro/index.vue';
import CompanyIntroMobile from '@/components/CompanyIntroMobile/index.vue';
import Partners from '@/components/partners/index'
import PartnersMobile from '@/components/partnersMobile/index'
import HonorCertificates from '@/components/HonorCertificates/index.vue';
import HonorCertificatesMobile from '@/components/HonorCertificatesMobile/index.vue';
import ContactUs from '@/components/ContactUs/index.vue'; // 新增导入组件
import ContactUsMobile from '@/components/ContactUsMobile/index.vue'; // 新增导入组件

export default {
    components: {
        PCNavbar,
        MobileNavBar,
        CallMe,
        MobileCallme,
        AboutUsHeader,
        AboutUsHeaderMobile,
        CompanyIntro,
        CompanyIntroMobile,
        HonorCertificates,
        HonorCertificatesMobile,
        Partners,
        PartnersMobile,
        ContactUs, // 注册新组件
        ContactUsMobile
    },
};
</script>

<style lang="scss" scoped>
.about-us {
    .about-us-header {
        margin-bottom: 20px;
    }

    .content {
        text-align: center;
        padding: 20px;

        h1 {
            font-size: 2rem;
            margin-bottom: 10px;
        }

        p {
            font-size: 1rem;
            color: #1E242A;
        }
    }
}

@media (max-width: 992) {
  .none_992 {
    display: none !important;
  }
}
</style>
